module.exports = __webpack_public_path__ + "img/ic_network_building.aed1c525.png";